
export default {
  props: {
    blok: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      avatarPositions: {
        0: { x: 735, y: 340 },
        1: { x: 240, y: 585 },
        2: { x: 735, y: 820 },
        3: { x: 240, y: 1105 },
        4: { x: 735, y: 1350 },
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      // text reveal on scroll
      this.$gsap.utils.toArray('.svg-item').forEach((avatar) => {
        const text = avatar.querySelector('.avatar-text')

        this.$gsap.from(text, {
          opacity: 0,
          duration: 1,
          scrollTrigger: {
            trigger: avatar,
            start: 'top center',
            end: 'bottom center',
            // markers: true,
            scrub: 0.5,
          },
        })
      })
    })
  },
  methods: {
    richTextToHtml(field) {
      return this.$storyapi.richTextResolver.render(field)
    },
  },
}
